import React from 'react';

type LayoutContentProps = {
    className?: string;
}
export const LayoutContent: React.FC<LayoutContentProps> = (props) => {
    const { children, className } = props;
    return <div className={`layout-content ${className}`}>{children}</div>;
};